import List from "@tw/product-discovery-merchandizing-cra/lib/shopping-faqs/list/list-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

List.domainName = "product-discovery";

export default PageWrapper(List);
